// components/StepsSection.js
import React from "react";
import { motion } from "framer-motion";
import { FaShoppingCart, FaFish, FaLeaf, FaSmile } from "react-icons/fa";

const STEPS = [
  { icon: <FaShoppingCart className="text-2xl text-blue-500" />, label: "Elige tu acuario" },
  { icon: <FaFish className="text-2xl text-yellow-500" />, label: "Selecciona tus peces" },
  { icon: <FaLeaf className="text-2xl text-green-500" />, label: "Añade decoración" },
  { icon: <FaSmile className="text-2xl text-pink-400" />, label: "Disfruta y aprende" },
];

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.12 }
  })
};

const StepsSection = () => (
  <motion.section
    className="container mx-auto py-12"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center">¿Cómo empezar tu acuario?</h2>
    <div className="flex flex-wrap justify-center gap-6">
      {STEPS.map((step, i) => (
        <motion.div
          key={i}
          className="flex flex-col items-center bg-white shadow rounded-2xl p-6 w-48 border hover:shadow-xl transition-all"
          custom={i}
          variants={fadeIn}
        >
          <div className="mb-3">{step.icon}</div>
          <div className="font-bold text-blue-900 text-lg mb-2">{step.label}</div>
        </motion.div>
      ))}
    </div>
  </motion.section>
);

export default StepsSection;
